export const invitation = {
    namespaced: true
};
